import { AvailableMemberTabTableHeader } from 'modals/ShiftModal/src/views/DetailView/AvailableMembersTab/AvailableMemberTabTableHeader';
import { AvailableMemberTabTableBody } from 'modals/ShiftModal/src/views/DetailView/AvailableMembersTab/AvailableMemberTabTableBody';
import { AvailableMemberTabTableWrapper } from 'modals/ShiftModal/src/views/DetailView/AvailableMembersTab/AvailabilityMemberTab.styled';

export const AvailableMemberTabTable = () => {
  return (
    <AvailableMemberTabTableWrapper>
      <AvailableMemberTabTableHeader />
      <AvailableMemberTabTableBody />
    </AvailableMemberTabTableWrapper>
  );
};
